import {toArray, flatten} from "lodash";

export function formatterErrorsLaravel(error, messageDefault = 'Não foi possível atender o pedido') {
    let formatted;

    if (error.hasOwnProperty('response') && error.response.hasOwnProperty('data')) {
        if (typeof error.response.data.errors === 'object') {
            formatted = flatten(toArray(error.response.data.errors));
        } else if (typeof error.response.data === 'object') {
            formatted = flatten(toArray(error.response.data));
        } else if (error.response.data.hasOwnProperty('message')) {
            formatted = [error.response.data.message];
        } else {
            formatted = [error.response.data];
        }
    } else if (error.hasOwnProperty('message')) {
        formatted = [error.message];
    } else {
        formatted = [messageDefault];
    }

    return formatted;
}

export const store = (url = null, name = null, title = "Pesquisa guardada com sucesso!") => {
    return axios.post(route('api.savedSearch.store'), {
        url: url ? url : window.location.href,
        name: name ? name : document.querySelector('#name-search').value
    }).then(() => {
        try {
            const modalSaveSearch = bootstrap.Modal.getOrCreateInstance(document.getElementById('modal-save-search'))
            modalSaveSearch.hide();
        } catch (e) {}
        // Swal.fire({
        //     position: 'top-end',
        //     toast: true,
        //     title,
        //     timer: 5000,
        //     timerProgressBar: true,
        //     icon: 'success',
        //     showConfirmButton: false,
        // })
        setTimeout(function () {
            $('#modal-save-search').modal('hide');
            $('#successSaveSearchModal').modal('show');
        }, 200);
        setTimeout(function () {
            $('#successSaveSearchModal').modal('hide')
        }, 3000);
        return Promise.resolve()
    }).catch((e) => {
        const errors = formatterErrorsLaravel(e)
        // Swal.fire({
        //     position: 'top-end',
        //     toast: true,
        //     title: errors.join('<br/>'),
        //     timer: 8000,
        //     timerProgressBar: true,
        //     icon: 'error',
        //     showConfirmButton: false,
        // })
        return Promise.reject()
    })
}

window.addEventListener('load', () => {
    const el = document.querySelector('#btn-store-search')
    if (el && ! el.getAttribute('data-observable')) {
        el.setAttribute('data-observable', '1')
        el.addEventListener('click', (e) => {
            e.preventDefault();
            store()
        })
    }
})
